module.exports = __webpack_public_path__ + "img/yjb_login_bg@2x.94330dcf.png";